/**
 * 新增 or 编辑 校验规则
 * author:brian author 2022 05 20
 */
// import * as validator from '@/utils/validate.js';
import { channelMask, checkNumber, EnNumber } from '../ownRules.js';

export function AddRules() {
    const args = Array.from(arguments);
    return {
        scene_id: [
            {
                required: true,
                message: $t('integration.customer_cannot_be_empty'),
                trigger: 'change'
            }
        ],
        nickname: [
            {
                required: true,
                message: $t('integration.nickname_cannot_be_empty'),
                trigger: 'blur'
            },
            {
                max: 30,
                message: $t('public.len_max_30'),
                change: 'blur'
            }
        ],
        type: [
            {
                required: true,
                message: (args['type'] && args['type'].message) || $t('integration.type_cannot_be_empty'),
                trigger: 'change'
            }
        ],
        extPanId: [
            { required: true, message: 'Ext Pan ID' + $t('integration.cannot_be_empty'), trigger: 'blur' },
            { max: 18, message: $t('integration.the_length_is_8_hex_bases_c__i_dot_e_dot__18'), trigger: 'blur' },
            {
                validator: this.$fromRules.FormValidate.Form().Code,
                trigger: 'blur'
            }
        ],
        channelPage: [
            { required: true, message: 'Join Attemp' + $t('integration.cannot_be_empty'), trigger: 'blur' },
            {
                validator: this.$fromRules.FormValidate.maxMinFn('channelPage').netRule
            }
        ],
        channelMask: [
            { required: true, message: $t('integration.channel_mask_cannot_be_empty'), trigger: 'blur' },
            {
                validator: channelMask,
                trigger: 'blur'
            }
        ],
        transmitPower: [
            { required: true, message: $t('integration.transmit_power_cannot_be_empty'), trigger: 'blur' },
            {
                validator: this.$fromRules.FormValidate.maxMinFn('channelPage').netRule,
                trigger: 'blur'
            }
        ],
        inNetInterval: [
            { required: true, message: $t('integration.the_network_access_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        appEui: [
            { required: true, message: $t('integration.appeui_cannot_be_empty'), trigger: 'blur' },
            {
                validator: EnNumber,
                trigger: 'blur'
            }
        ],
        appKey: [
            { required: true, message: $t('integration.appkey_cannot_be_empty'), trigger: 'blur' },
            {
                validator: EnNumber,
                trigger: 'blur'
            }
        ],
        // 上报规则
        collectInterval: [
            { required: true, message: $t('integration.collection_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        exCollectInterval: [
            { required: true, message: $t('integration.exception_collection_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        tempCollectInterval: [
            { required: true, message: $t('integration.the_temperature_collection_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],

        tempChange: [
            { required: true, message: $t('integration.temperature_change_threshold_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        tempMaxReport: [
            { required: true, message: $t('integration.the_maximum_temperature_reporting_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        tempMinReport: [
            { required: true, message: $t('integration.the_minimum_reporting_interval_of_temperature_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        humCollectInterval: [
            { required: true, message: $t('integration.humidity_collection_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        humChange: [
            { required: true, message: $t('integration.humidity_change_threshold_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        humMaxReport: [
            { required: true, message: $t('integration.the_maximum_humidity_reporting_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ],
        humMinReport: [
            { required: true, message: $t('integration.the_minimum_humidity_reporting_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: checkNumber,
                trigger: 'blur'
            }
        ]
    };
}
